/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FundingGoal,
  FundingGoalInput,
  FundingGoals,
  FundingGoalsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Funding Goal
 */
export const createFundingGoal = (
    fundingGoalInput: MaybeRefOrGetter<FundingGoalInput>,
 signal?: AbortSignal
) => {
      fundingGoalInput = toValue(fundingGoalInput);

      return axiosClient<FundingGoal>(
      {url: `/funding-goals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundingGoalInput, signal
    },
      );
    }




export const getCreateFundingGoalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFundingGoal>>, TError,{data: FundingGoalInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFundingGoal>>, TError,{data: FundingGoalInput}, TContext> => {

const mutationKey = ['createFundingGoal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFundingGoal>>, {data: FundingGoalInput}> = (props) => {
          const {data} = props ?? {};

          return  createFundingGoal(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFundingGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createFundingGoal>>>
    export type CreateFundingGoalMutationBody = FundingGoalInput
    export type CreateFundingGoalMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Funding Goal
 */
export const useCreateFundingGoal = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFundingGoal>>, TError,{data: FundingGoalInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFundingGoal>>,
        TError,
        {data: FundingGoalInput},
        TContext
      > => {
      return useMutation(getCreateFundingGoalMutationOptions(options), queryClient);
    }
    /**
 * @summary Funding Goals list
 */
export const fundingGoals = (
    params?: MaybeRefOrGetter<FundingGoalsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FundingGoals>(
      {url: `/funding-goals`, method: 'GET',
        params, signal
    },
      );
    }




export const getFundingGoalsQueryKey = (params?: MaybeRefOrGetter<FundingGoalsParams>,) => {
    return [
    'funding-goals', ...(params ? [params] : [])
    ] as const;
    }


export const getFundingGoalsQueryOptions = <TData = Awaited<ReturnType<typeof fundingGoals>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FundingGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundingGoals>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFundingGoalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundingGoals>>> = ({ signal }) => fundingGoals(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundingGoals>>, TError, TData>
}

export type FundingGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof fundingGoals>>>
export type FundingGoalsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Funding Goals list
 */

export function useFundingGoals<TData = Awaited<ReturnType<typeof fundingGoals>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FundingGoalsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundingGoals>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFundingGoalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Funding Goal
 */
export const destroyFundingGoal = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FundingGoal>(
      {url: `/funding-goals/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFundingGoalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFundingGoal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFundingGoal>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyFundingGoal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFundingGoal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyFundingGoal(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFundingGoalMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFundingGoal>>>

    export type DestroyFundingGoalMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Funding Goal
 */
export const useDestroyFundingGoal = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFundingGoal>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFundingGoal>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyFundingGoalMutationOptions(options), queryClient);
    }
    /**
 * @summary Funding Goal Detail
 */
export const fundingGoal = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FundingGoal>(
      {url: `/funding-goals/${id}`, method: 'GET', signal
    },
      );
    }




export const getFundingGoalQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'funding-goals',id
    ] as const;
    }


export const getFundingGoalQueryOptions = <TData = Awaited<ReturnType<typeof fundingGoal>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundingGoal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFundingGoalQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundingGoal>>> = ({ signal }) => fundingGoal(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundingGoal>>, TError, TData>
}

export type FundingGoalQueryResult = NonNullable<Awaited<ReturnType<typeof fundingGoal>>>
export type FundingGoalQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Funding Goal Detail
 */

export function useFundingGoal<TData = Awaited<ReturnType<typeof fundingGoal>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundingGoal>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFundingGoalQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Funding Goal
 */
export const updateFundingGoal = (
    id: MaybeRefOrGetter<string>,
    fundingGoalInput: MaybeRefOrGetter<FundingGoalInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fundingGoalInput = toValue(fundingGoalInput);

      return axiosClient<FundingGoal>(
      {url: `/funding-goals/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fundingGoalInput, signal
    },
      );
    }




export const getUpdateFundingGoalMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFundingGoal>>, TError,{id: string;data: FundingGoalInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFundingGoal>>, TError,{id: string;data: FundingGoalInput}, TContext> => {

const mutationKey = ['updateFundingGoal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFundingGoal>>, {id: string;data: FundingGoalInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFundingGoal(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFundingGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateFundingGoal>>>
    export type UpdateFundingGoalMutationBody = FundingGoalInput
    export type UpdateFundingGoalMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Funding Goal
 */
export const useUpdateFundingGoal = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFundingGoal>>, TError,{id: string;data: FundingGoalInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFundingGoal>>,
        TError,
        {id: string;data: FundingGoalInput},
        TContext
      > => {
      return useMutation(getUpdateFundingGoalMutationOptions(options), queryClient);
    }
